import * as types from "./actionTypes";
import * as eventApi from "../../api/eventApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadAttendingSuccess(attending) {
  return { type: types.LOAD_ATTENDING_SUCCESS, attending };
}

export function signUpOptimistic(attending) {
  return { type: types.SIGNUP_OPTIMISTIC, attending };
}

export function unSignUpOptimistic(attending) {
  return { type: types.UN_SIGNUP_OPTIMISTIC, attending };
}

export function getAttending(accessToken) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return eventApi
      .getAttending(accessToken)
      .then(attending => {
        dispatch(loadAttendingSuccess(attending));
        return attending;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

//will probably not use in the future
export function getAttendingEventsThisWeek(accessToken) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return eventApi
      .getAttendingEventsThisWeek(accessToken)
      .then(attendingEvents => {
        dispatch(loadAttendingSuccess(attendingEvents));
        return attendingEvents;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function signUp(accessToken, attendingEvent, userId) {
  return function (dispatch) {
    dispatch(signUpOptimistic(attendingEvent));
    return eventApi.signUp(accessToken, attendingEvent, userId);
  };
}

export function unSignUp(accessToken, event, userId) {
  return function (dispatch) {
    dispatch(unSignUpOptimistic(event, userId));
    return eventApi.unSignUp(accessToken, event, userId);
  };
}
